export default __webpack_public_path__ + "static/media/017-sailboat.97ced587.svg";